import React from "react";
import { Link } from "react-router-dom";
import Slider from "react-slick";
import axios from "axios";
import { useState, useEffect } from "react";
import { addToCart } from "../helper/cartfunction";

const OrganicOne = () => {
  const [data, setData] = useState([]);

  function fetchdata() {
    axios
      .get(process.env.REACT_APP_BACKEND_URI + "/categories/featured")
      .then((response) => {
        setData(response.data.featured_data);
        console.log("Featured Data", response.data.featured_data);
      })
      .catch((error) => {
        alert(error);
      });
  }

  useEffect(() => {
    fetchdata();
  }, []);

  function SampleNextArrow(props) {
    const { className, onClick } = props;
    return (
      <button
        type="button"
        onClick={onClick}
        className={` ${className} slick-next slick-arrow flex-center rounded-circle border border-gray-100 hover-border-main-600 text-xl hover-bg-main-600 hover-text-white transition-1`}
      >
        <i className="ph ph-caret-right" />
      </button>
    );
  }

  function SamplePrevArrow(props) {
    const { className, onClick } = props;
    return (
      <button
        type="button"
        onClick={onClick}
        className={`${className} slick-prev slick-arrow flex-center rounded-circle border border-gray-100 hover-border-main-600 text-xl hover-bg-main-600 hover-text-white transition-1`}
      >
        <i className="ph ph-caret-left" />
      </button>
    );
  }

  const calculateDiscountedPrice = (price, discount, discountType) => {
    if (discountType === "amount") {
      return price - discount;
    }
    if (discountType === "percent") {
      return price - (price * discount) / 100;
    }
    return price;
  };

  const calculateDiscountPercent = (price, discount, discountType) => {
    if (discountType === "percent") {
      return discount;
    }
    if (discountType === "amount") {
      return ((discount / price) * 100).toFixed(0);
    }
    return 0;
  };

  const settings = {
    dots: false,
    arrows: true,
    infinite: true,
    speed: 1000,
    slidesToShow: 6,
    slidesToScroll: 1,
    initialSlide: 0,
    autoplay: true,
    nextArrow: <SampleNextArrow />,
    prevArrow: <SamplePrevArrow />,
    responsive: [
      {
        breakpoint: 1599,
        settings: {
          slidesToShow: 5,
        },
      },
      {
        breakpoint: 1399,
        settings: {
          slidesToShow: 5,
        },
      },
      {
        breakpoint: 992,
        settings: {
          slidesToShow: 2,
        },
      },
      {
        breakpoint: 575,
        settings: {
          slidesToShow: 2,
        },
      },
      {
        breakpoint: 424,
        settings: {
          slidesToShow: 2,
        },
      },
    ],
  };

  return (
    <>
      {data.map((item) => (
        <section className="organic-food pb-80">
          <div className="container container-lg">
            <div className="section-heading p-8">
              <div className="flex-between flex-wrap gap-8">
                <h5 className="mb-0">{item.category.name}</h5>
                <div className="flex-align mr-point gap-16">
                  <Link
                    to="/shop"
                    className="text-sm fw-medium text-gray-700 hover-text-main-600 hover-text-decoration-underline"
                  >
                    All Categories
                  </Link>
                </div>
              </div>
            </div>
            <div className="organic-food__slider arrow-style-two">
              <Slider {...settings}>
                {item.products.map((product) => (
                  <div className="product-card h-100 p-8 border border-gray-100 hover-border-main-600 rounded-16 position-relative transition-2">
                    <Link
                      to={`/product-details/${product.id}/`}
                      className="product-card__thumb flex-center"
                    >
                      <img src={product.image_fullpath[0]} alt="" />
                    </Link>
                    <div className="product-card__content mt-12">
                    <Link
                          to={`/product-details/${product.id}/`}
                         
                        >
                      <h6 className="title text-lg fw-semibold mt-12 mb-8">
                         
                          {product.name}
                         
                      </h6>
                      </Link>

                      <div className="flex-between gap-8 mt-24 flex-wrap">
                        <div className="product-card__price">
                          <span className="text-gray-400 text-md fw-semibold text-decoration-line-through d-block">
                            Rs.{product.price}
                          </span>
                          <span className="text-heading text-md fw-semibold ">
                            Rs.
                            {calculateDiscountedPrice(
                              product.price,
                              product.discount,
                              product.discount_type
                            ).toFixed(2)}{" "}
                            <span className="text-gray-500 fw-normal">
                              /Qty
                            </span>{" "}
                          </span>
                        </div>
                        <button
                          onClick={() => {
                            addToCart(product.id, 1);
                          }}
                          className="product-card__cart btn bg-main-50 text-main-600 hover-bg-main-600 hover-text-white py-11 px-24 rounded-pill flex-align gap-8"
                        >
                          Add <i className="ph ph-shopping-cart" />
                        </button>
                      </div>
                    </div>
                  </div>
                ))}
              </Slider>
            </div>
          </div>
        </section>
      ))}
    </>
  );
};

export default OrganicOne;
